import React from "react";
import { format } from "date-fns";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { useToast } from "../ui/use-toast";
import { shareStatus } from "../../lib/share-game";
import { GameStatusContext } from "../../providers/GameStatus";
import { PuzzleDataContext } from "../../providers/PuzzleData";
import { SPORT_LABELS } from "../../lib/constants";

function ShareScoreButton({ buttonText = "Share", className = "" }) {
    const { gameData, puzzleDate, sport, puzzleId } =
        React.useContext(PuzzleDataContext);
    const { submittedGuesses } = React.useContext(GameStatusContext);
    const { toast } = useToast();
    function handleShareToClipboard() {
        toast({
            label: "Notification",
            title: "",
            description: "Copied to clipboard!",
            className: "bg-slate-900 text-white border-slate-700",
        });
    }
    function handleShareFailure() {
        toast({
            label: "Notification",
            title: "",
            description: "Was unable to copy to clipboard / share.",
            variant: "destructive",
        });
    }
    const puzzleLabel = React.useMemo(() => {
        const sportLabel = SPORT_LABELS[sport] ?? sport?.toUpperCase();
        const dateLabel = puzzleDate ? format(new Date(puzzleDate), "MMM d") : "";
        const idLabel = puzzleId ? ` #${String(puzzleId).slice(0, 8)}` : "";
        return [sportLabel, dateLabel].filter(Boolean).join(" • ") + idLabel;
    }, [puzzleDate, puzzleId, sport]);

    return (
        <Button
            className={cn(className, "w-full")}
            variant="share"
            onClick={() =>
                shareStatus(
                    gameData,
                    submittedGuesses,
                    handleShareToClipboard,
                    handleShareFailure,
                    true,
                    puzzleLabel
                )
            }
        >
            {buttonText}
        </Button>
    );
}

export default ShareScoreButton;
